// extracted by mini-css-extract-plugin
export default {"badge":"badge_badge__Uj949","badge-warning":"badge_badge-warning__V7KQP","badge-success":"badge_badge-success__hNndz"};